<template>
	<div id="app">
		<router-view v-if="isRouterAlive"></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},
			//返回顶部
			// backTop(){
			// 	const that = this
			// 	let timer = setInterval(()=>{
			// 		let isPeed = Math.floor(-that.scrollTop/5)
			// 		document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop+isPeed
			// 		if(that.scrollTop === 0){
			// 			clearInterval(timer)
			// 		}
			// 	},16)
			// },
			// //计算顶部距离
			// scrollToTop(){
			// 	const that = this
			// 	let scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop
			// 	that.scrollTop = scrollTop
			// 	if(that.scrollTop > 60){
			// 		that.binFlag = true
			// 	}else{
			// 		that.binFlag = false
			// 	}
			// }
		}
	}
</script>


<style>
	body {
		overflow: hidden;
	}

	#app,
	.fullpage,
	body {
		height: 100%;
	}

	/* #app {
		font-family: Helvetica, sans-serif;
		text-align: center;
	} */

	* {
		margin: 0;
		padding: 0;
		font-family: Helvetica, sans-serif;
		-webkit-touch-callout: none;
		/* 系统默认菜单被禁用 */
		-webkit-user-select: none;
		/* webkit浏览器 */
		-khtml-user-select: none;
		/* 早期浏览器 */
		-moz-user-select: none;
		/* 火狐 */
		-ms-user-select: none;
		/* IE10 */
		user-select: none;
		
	}

	a {
		text-decoration: none;
	}

	ol,
	ul {
		list-style: none;
	}
	img{
		pointer-events: none;
	}
	/* .fiexdMenu {
		position: fixed;
		right: 3%;
		bottom: 10%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		z-index: 999;
	} */

	.advisor {
		width: 30px;
		height: 30px;
		margin-bottom: 10px;
		background-image: url(assets/images/advisor.png);
		background-size: 20px 20px;
		position: relative;
		border: 1px solid #707070;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-position: center;
		background-color: #f7f8fa;
	}
	.advisor:hover{
		background-image: url(assets/images/advisorActive.png);
		border: 1px solid #FF8500;
		background-color:#fff;
	}
	.program {
		width: 30px;
		height: 30px;
		margin-bottom: 10px;
		background-image: url(assets/images/program.png);
		background-size: 20px 20px;
		position: relative;
		border: 1px solid #707070;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-position: center;
		background-color: #f7f8fa;
	}
	.program:hover{
		background-image: url(assets/images/programActive.png);
		border: 1px solid #FF8500;
		background-color:#fff;
	}
	.cellphone {
		width: 30px;
		height: 30px;
		margin-bottom: 10px;
		background-image: url(assets/images/phone.png);
		background-size: 20px 20px;
		position: relative;
		border: 1px solid #707070;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-position: center;
		background-color: #f7f8fa;
	}
	.cellphone:hover{
		background-image: url(assets/images/phoneActive.png);
		border: 1px solid #FF8500;
		background-color:#fff;
	}
	.up {
		width: 30px;
		height: 30px;
		margin-bottom: 10px;
		background-image: url(assets/images/up.png);
		background-size: 20px 20px;
		position: relative;
		border: 1px solid #707070;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-position: center;
		background-color: #f7f8fa;
	}

	.inner-box {
		width: 1200px;
		margin: 0 auto;
	}

	@keyframes contentFromBottom2Top {
		0% {
			transform: translate3d(0, 1750px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes contentFromTop2Bottom {
		0% {
			transform: translate3d(0, -1750px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes contentFromLeft2Right {
		0% {
			transform: translate3d(-1750px, 0, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes contentFromRight2Left {
		0% {
			transform: translate3d(1750px, 0, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}
	@keyframes fadeInDown {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,-100%,0);
			transform: translate3d(0,-100%,0);
		}
	
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,-100%,0);
			transform: translate3d(0,-100%,0);
		}
	
		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue